/**
 * Determines if a page path should have the workers experiment enabled.
 * Returns true if the path starts with "/ecom/shop/browse/offers" or "/ecom/recipes",
 * otherwise returns false.
 *
 * @param path - The page path to check
 * @returns true if the path should enable the workers experiment, false otherwise
 */
export const isPageWorkersExperimentPath = (path: string): boolean => {
  return path.startsWith('/ecom/shop/browse/offers') || path.startsWith('/ecom/recipes');
};
